import { useState } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PillButton from "../../ui/components/PillButton";
import { ReactComponent as PinIcon } from "../../static/assets/dashboard-pin.svg";
import { readBooleanStorage, writeBooleanStorage } from "./dashboardKpiUtils";

const STORAGE_KEY = "dashboard.sitesOpen";

const openMonitoring = (history, addressName) => {
  if (addressName) {
    history.push({
      pathname: "/containers",
      state: { addressF: addressName },
    });
    return;
  }
  history.push("/containers");
};

const sortSitesByName = (addresses) =>
  [...addresses].sort((left, right) =>
    (left.addressName || "").localeCompare(right.addressName || "", undefined, {
      sensitivity: "base",
    }),
  );

export const DashboardSites = ({ addresses = [] }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const [isOpen, setIsOpen] = useState(() =>
    readBooleanStorage(STORAGE_KEY, true),
  );

  const toggleOpen = () => {
    setIsOpen((current) => {
      const next = !current;
      writeBooleanStorage(STORAGE_KEY, next);
      return next;
    });
  };

  if (!addresses.length) return null;

  const sites = sortSitesByName(addresses);

  return (
    <section className="dashboard-sites">
      <div className={`dashboard-sorting-header${isOpen ? " is-open" : ""}`}>
        <button
          type="button"
          className="dashboard-sorting-toggle"
          onClick={toggleOpen}
          aria-expanded={isOpen}
          aria-controls="dashboard-sites-panel"
        >
          <h3 className="dashboard-campaigns-title">{t("dashboard.sites")}</h3>
          <i
            className={`fas fa-chevron-down dashboard-sorting-chevron${isOpen ? " is-open" : ""}`}
            aria-hidden="true"
          />
        </button>
      </div>
      {isOpen ? (
        <div id="dashboard-sites-panel">
          <article className="dashboard-sites-card">
            <ul className="dashboard-sites-list">
              {sites.map((address, index) => {
                const zoneCount = address.count || 0;
                return (
                  <li key={address.addressName || index}>
                    <button
                      type="button"
                      className="dashboard-sites-row"
                      onClick={() =>
                        openMonitoring(history, address.addressName)
                      }
                    >
                      <PinIcon
                        className="dashboard-sites-pin"
                        aria-hidden="true"
                      />
                      <span
                        className="dashboard-sites-name"
                        title={address.addressName}
                      >
                        {address.addressName || "—"}
                      </span>
                      <span className="dashboard-sites-zones">
                        {t(
                          `dashboard.zoneCount${zoneCount > 1 ? "_plural" : ""}`,
                          {
                            count: zoneCount,
                          },
                        )}
                      </span>
                      <i
                        className="fas fa-chevron-right dashboard-sites-chevron"
                        aria-hidden="true"
                      />
                    </button>
                  </li>
                );
              })}
            </ul>
          </article>
          <PillButton
            size="md"
            className="dashboard-campaigns-all"
            onClick={() => openMonitoring(history)}
          >
            {t("dashboard.viewAllMonitoring")}
          </PillButton>
        </div>
      ) : null}
    </section>
  );
};
